import { API_URL } from "../config/connect";

const request = async (path, { method = "GET", body } = {}) => {
    const token = localStorage.getItem("google_id_token");
    const response = await fetch(`${API_URL}${path}`, {
        method,
        headers: {
            Authorization: `Bearer ${token}`,
            ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        const d = data.detail;
        const message =
            response.status === 403
                ? "Недостаточно прав — менять категории может только администратор."
                : (typeof d === "string" && d) || (Array.isArray(d) && d.map((x) => x.msg).join("; ")) || `HTTP ${response.status}`;
        const error = new Error(message);
        error.status = response.status;
        throw error;
    }
    return response.json();
};

export const listAdminCategories = (refresh = false) =>
    request(`/api/v1/admin/categories${refresh ? "?refresh=true" : ""}`).then((d) => d.items || []);
export const updateAdminCategory = (id, body) => request(`/api/v1/admin/categories/${id}`, { method: "PATCH", body });
export const setPinnedCategories = (ids) => request("/api/v1/admin/categories/pinned", { method: "PUT", body: { ids } });
export const mergeCategory = (sourceId, targetId) =>
    request(`/api/v1/admin/categories/${sourceId}/merge`, { method: "POST", body: { target_id: targetId } });

// Рубрики (группы на главной сайта) и подкатегории
export const listAdminRubrics = () => request("/api/v1/admin/rubrics");
export const createRubric = (body) => request("/api/v1/admin/rubrics", { method: "POST", body });
export const updateRubric = (id, body) => request(`/api/v1/admin/rubrics/${id}`, { method: "PATCH", body });
export const deleteRubric = (id) => request(`/api/v1/admin/rubrics/${id}`, { method: "DELETE" });

export const listSubcategories = (categoryId) =>
    request(`/api/v1/admin/categories/${categoryId}/subcategories`).then((d) => d.items || []);
export const createSubcategory = (categoryId, body) =>
    request(`/api/v1/admin/categories/${categoryId}/subcategories`, { method: "POST", body });
export const updateSubcategory = (id, body) => request(`/api/v1/admin/subcategories/${id}`, { method: "PATCH", body });
export const deleteSubcategory = (id) => request(`/api/v1/admin/subcategories/${id}`, { method: "DELETE" });
export const mergeSubcategory = (sourceId, targetId) =>
    request(`/api/v1/admin/subcategories/${sourceId}/merge`, { method: "POST", body: { target_id: targetId } });
